import {
    adminfunThumbnail,
    buddysystemThumbnail,
    imlcguiThumbnail,
    kingfaris10Thumbnail,
    kingkitsThumbnail,
    llvmThumbnail,
} from '@/assets/images/portfolio';

export interface PortfolioProject {
    id: string;
    title: string;
    description: string;
    image: string;
    link?: string;
    technologies?: string[];
}

export const portfolioProjects: PortfolioProject[] = [
    {
        id: 'imlcgui',
        title: 'IMLCGui',
        description:
            'A lightweight GUI wrapper for the Intel Memory Latency Checker, used for measuring bandwidth and latency and is useful when overclocking memory.',
        image: imlcguiThumbnail,
        technologies: ['C#', 'WPF'],
        link: 'https://github.com/FarisR99/IMLCGui',
    },
    {
        id: 'llvm-flang',
        title: 'LLVM Flang',
        description: 'A Fortran frontend compiler. I have worked on the new Flang driver that replaces f18.',
        image: llvmThumbnail,
        technologies: ['C++', 'Open Source'],
        link: 'https://github.com/llvm/llvm-project/tree/main/flang',
    },
    {
        id: 'kingkits',
        title: 'KingKits',
        description:
            'An add-on software with over 530,000 downloads made for Minecraft servers to change the way the game is meant to be played.',
        image: kingkitsThumbnail,
        technologies: ['Java'],
        link: 'https://dev.bukkit.org/projects/kingkits/',
    },
    {
        id: 'adminfun',
        title: 'AdminFun',
        description:
            'An add-on software with over 820,000 downloads made for Minecraft servers to allow administrators to enjoy the game just as much as users do.',
        image: adminfunThumbnail,
        technologies: ['Java'],
        link: 'https://dev.bukkit.org/projects/adminfun/',
    },
    {
        id: 'buddysystem',
        title: 'BuddySystem',
        description:
            'A university project to pair first year undergraduates with more senior "buddies" using a questionnaire with algorithms behind it.',
        image: buddysystemThumbnail,
        technologies: ['Laravel', 'PHP'],
    },
    {
        id: 'pc-blog',
        title: 'PC Building & Overclocking Blog',
        description:
            'A website that aims to help first-time desktop builders select components for their computer. Additionally I write blog posts investigating various hardware topics such as the impact of RAM overclocking on performance.',
        image: kingfaris10Thumbnail,
        technologies: ['React', 'TypeScript', 'Laravel', 'PHP'],
        link: 'https://kingfaris.co.uk',
    },
];
